import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {layoutPaths} from '../../../theme';
import { GlobalState } from '../../global.state';

@Pipe({name: 'labelPipe'})
@Injectable()
export class LabelPipe implements PipeTransform {
    constructor(private state: GlobalState  ) {}

    transform(input:string, params?: { [key: string]: any }):string {
        let data = this.state.getGlobalSetting("label-dictionary");   
        if(!data) 
            data = <any[]>JSON.parse(sessionStorage.getItem("label-dictionary"));
        return data.filter(item => item.key === input)[0].value;
    }
}